import React, { FC, useEffect, useState } from 'react';

import WebdoorContent from './WebdoorContent';
import withMediaQueries from '../MediaQueries';
import { MOTION_DURATION, useAnimateOnView } from '../../animations';

import { IWebdoor } from './interfaces';

import './styles.scss';

// webdoor
const Webdoor: FC<IWebdoor> = ({
  lang,
  queries,
  value
}) => {
  // --- ANIMATIONS: one-shot viewport entrance (text stagger); zoom runs per active item in styles ---
  const { ref, animProps, isAnimated } = useAnimateOnView<HTMLDivElement>({
    threshold: 0.2,
    rootMargin: '0px',
  });
  const [ entranceDone, setEntranceDone ] = useState(false);

  useEffect(() => {
    if (!isAnimated || entranceDone) return;

    const timer = window.setTimeout(
      () => setEntranceDone(true),
      MOTION_DURATION.textFade + MOTION_DURATION.header
    );

    return () => window.clearTimeout(timer);
  }, [ entranceDone, isAnimated ]);
  // --- /ANIMATIONS ---

  // render
  return (
    <div
      className="webdoor"
      ref={ref}
      {...animProps}
      data-entrance={entranceDone ? 'done' : 'pending'}>
      <WebdoorContent
        items={value}
        queries={queries}
        lang={lang} />
    </div>
  );
};

export default withMediaQueries(Webdoor);